import { Box, Button } from '@chakra-ui/react';
import { Form, useFormikContext } from 'formik';
import React from 'react';
import { localise } from '../../../services/lang/lang';
import { FormContainer } from '../Form/FormContainer';
import StandardFormTextArea from '../Form/StandardFormTextArea';
import { useTokens } from '../../../context/TokenProvider';
import StandardFormCheckboxGroup from '../Form/StandardFormCheckboxGroup';
const NegativeRatingForm = ({ reasons, onCancel }) => {
    const tokens = useTokens();
    const { handleSubmit, values, resetForm, errors, dirty, isSubmitting, handleChange, setFieldValue, } = useFormikContext();
    return (React.createElement(Form, { "data-testid": "negative_rating_form" },
        React.createElement(FormContainer, { gap: tokens.Spacing04 },
            React.createElement(StandardFormCheckboxGroup, { px: tokens.Spacing02, label: localise('SELECT_ALL_THAT_APPLY'), name: "reasons", options: reasons, value: values.reasons || [], error: errors.reasons, onChange: (newReasons) => setFieldValue('reasons', newReasons) }),
            React.createElement(Box, { w: "100%", px: tokens.Spacing02 },
                React.createElement(StandardFormTextArea, { error: errors.description, value: values.description, label: localise('DESCRIPTION'), onChange: handleChange, name: "description", placeholder: localise('DESCRIBE_WHY_NOT_USEFUL') })),
            React.createElement(Button, { isDisabled: !dirty || isSubmitting, isLoading: isSubmitting, onClick: () => handleSubmit(), variant: "primary", width: "100%" }, localise('SUBMIT_FEEDBACK')),
            React.createElement(Button, { isDisabled: isSubmitting, "data-testid": "negative_rating_form__cancel_button", onClick: () => {
                    resetForm();
                    onCancel();
                }, variant: "secondary", width: "100%" }, localise('CANCEL')))));
};
export default NegativeRatingForm;
